import themeConfig from "./config";

const fontFamily = {
  // 思源黑體
  main: "'Noto Sans TC'",
};

// 使用倍率方式放大
// const scale = (fontSizeScale) =>
//   themeConfig.htmlFontSizeScale[Number.parseInt(fontSizeScale, 10)] / 14;
//

// 使用加減 px 放大/所小
const scale2 = (fontSizeScale) =>
  themeConfig.htmlFontSizeAdjust[Number.parseInt(fontSizeScale, 10)];

const typography = (fontSizeScale) => ({
  htmlFontSize: 16,
  fontFamily: fontFamily.main,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    // fontSize: `${6 * scale(fontSizeScale)}rem`,
    // fontSize: `${96 + scale2(fontSizeScale)}px`,
  },
  h2: {
    // fontSize: `${3.75 * scale(fontSizeScale)}rem`,
    // fontSize: `${60 + scale2(fontSizeScale)}px`,
  },
  // title lg
  h3: {
    // fontSize: `${3 * scale(fontSizeScale)}rem`,
    // fontSize: `${48 + scale2(fontSizeScale)}px`,
  },
  // title md
  h4: {
    // fontSize: `${2.125 * scale(fontSizeScale)}rem`,
    // fontSize: `${34 + scale2(fontSizeScale)}px`,
  },
  // title sm
  h5: {
    // fontSize: `${1.5 * scale(fontSizeScale)}rem`,
    // fontSize: `${24 + scale2(fontSizeScale)}px`,
  },
  h6: {
    // fontSize: `${1.25 * scale(fontSizeScale)}rem`,
    // fontSize: `${20 + scale2(fontSizeScale)}px`,
  },
  subtitle1: {
    // fontSize: `${1 * scale(fontSizeScale)}rem`,
    // fontSize: `${16 + scale2(fontSizeScale)}px`,
  },
  subtitle2: {
    // fontSize: `${0.875 * scale(fontSizeScale)}rem`,
    // fontSize: `${14 + scale2(fontSizeScale)}px`,
  },
  // body normal
  body1: {
    // fontSize: `${1 * scale(fontSizeScale)}rem`,
    // fontSize: `${16 + scale2(fontSizeScale)}px !important`, // use for timeline
  },
  // body small
  body2: {
    // fontSize: `${0.875 * scale(fontSizeScale)}rem`,
    // fontSize: `${14 + scale2(fontSizeScale)}px !important`, // use for timeline
  },
  // cation text
  caption: {
    // fontSize: `${0.75 * scale(fontSizeScale)}rem`,
    // fontSize: `${12 + scale2(fontSizeScale)}px !important`, // use for timeline
  },
  button: {
    // fontSize: `${0.875 * scale(fontSizeScale)}rem`,
    // fontSize: `${14 + scale2(fontSizeScale)}px`,
  },
  overline: {
    // fontSize: `${0.75 * scale(fontSizeScale)}rem`,
    // fontSize: `${12 + scale2(fontSizeScale)}px`,
  },
});

export default typography;
